import classes from './Login.module.scss' ;
import useInput from '../../Hooks/Use-Input';
import {Container , Row , Col  } from 'react-bootstrap' 
import {useNavigate } from 'react-router-dom';
import Modal from './Modal'
import { FaUserAlt } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";


const   Login = ({credential,message}) => {
    const navigate = useNavigate();
    const onClose = ()=>{
        navigate('/' )
    }

    //-----------------------------------------------------------------------
    const {value : enteredName ,hasError : nameInputIsInvalid , valueIsValid : enteredNameIsValid ,
        valueChangeHandler : nameInputChangeHandler , inputBlurHandler : nameInputBlurHandler ,
        reset : resetNameInput} = useInput(value => value.trim() !=='') ;
    const {value : enteredPass ,hasError : passIsInvalid , valueIsValid : passIsValid ,
        valueChangeHandler : passInputChangeHandler , inputBlurHandler : passInputBlurHandler ,
        reset : resetpass} = useInput(value => value.trim() !=='') ;

    //=======================================================
    let formIsValid = false
    if(enteredNameIsValid &&passIsValid){
    formIsValid = true;
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        if(!formIsValid){
            return;
        } ;
        credential(enteredName ,enteredPass);
        resetNameInput();
        resetpass();
    };
    //--------------------------------------------------
    const nameInputClasses = nameInputIsInvalid? `${classes["form-control"]} ${classes.invalid}` :
    `${classes["form-control"]}` ;
    const passInputClasses = passIsInvalid? `${classes["form-control"]} ${classes.invalid}` :
    `${classes["form-control"]}` ;
    //----------------------------------------------------------

    return(
        <Modal onClose={onClose} >
            <Container >
                <section className={`${classes.secpro} w-100`}>
                    <Row md={2} xs={1} lg={3} className={`g-5 p-md-3 gap-5  justify-content-center`}>
                        <Col  className={`${classes["contact-col"]} flex-fill`}>
                            <form  onSubmit={handleSubmit}>
                                <Col className={`d-flex flex-column justify-content-center  p-lg-4 align-items-center`}>
                                <Row className={`${nameInputClasses} d-flex flex-column align-items-center w-100`} >
                                    <label htmlFor='f-name'><FaUserAlt /> Username</label>
                                    <input type='text' id='f-name' name="Name" placeholder="Your  Username" required
                                    onChange={nameInputChangeHandler} value={enteredName} onBlur={nameInputBlurHandler} />
                                    {nameInputIsInvalid && <p className={classes['error-text']}>Your Username must not be empty</p>}
                                </Row>
                                <Row className={`${passInputClasses} d-flex flex-column align-items-center w-100`}>
                                    <label htmlFor='company-name'><RiLockPasswordFill /> Password</label>
                                    <input type='password' id='Password'  name="Password" placeholder="Your Password" required 
                                    onChange={passInputChangeHandler} value={enteredPass} onBlur={passInputBlurHandler} />
                                    {passIsInvalid && <p className={classes['error-text']}>Password must not be empty</p>}
                                </Row>
                                <Row className={`${classes["form-actions"]} d-flex flex-column align-items-center w-100 m-0`}>
                                    <button disabled={!formIsValid} className={`${classes["form-btn"]} `}>{formIsValid?'Login':'Enter your Username and Password'}</button>
                                    {message && <span className={`text-danger mt-3 fst-italic fs-6`}>{message}</span>}
                                </Row>
                                </Col>
                            </form>
                        </Col>
                    </Row>
                </section>
            </Container>
        </Modal>
    )
}
export default Login